import {
  generateDatedSlots,
  generateDates,
  isValidMedicationSlotWithProviderFilter,
} from 'app/ProviderSearch/utils'
import { TimeOfDay } from 'constants/common'
import { getSlotWithTimeOfDayAdded } from './common'

type GetProviderSlotDetailsResult = {
  generatedSlots: DateSlot
  dates: Date[]
  count: number
}

export const getProviderSlotDetails = (
  providerDetails: Provider,
  providerSlots: NormalizedProviderSchedule,
  providerId: string,
  startSlotDate: Date,
  slotListLimit: number,
  counselingTypedFilters: ProviderFilter[],
  slotsRowLimit: number,
  timeOfDay: TimeOfDay[],
  timeZone: string
): GetProviderSlotDetailsResult => {
  const dateSlots: DateSlot = providerSlots[providerId] || {}
  const dates: Date[] = generateDates(startSlotDate, slotListLimit)
  const generatedSlots = generateDatedSlots(
    dates,
    dateSlots,
    (slot: ProviderSlot) => {
      if (
        !isValidMedicationSlotWithProviderFilter(
          providerDetails,
          slot,
          counselingTypedFilters
        )
      ) {
        return null
      } else if (timeOfDay.length > 0) {
        return getSlotWithTimeOfDayAdded(slot, timeOfDay, timeZone)
      }

      return slot
    }
  )

  let shownSlotsCount = 0

  if (slotsRowLimit !== 0) {
    Object.keys(generatedSlots).map((slotDate) => {
      const slots = generatedSlots[slotDate]

      for (let index = 0; index < slotsRowLimit; index++) {
        const currentSlot = slots[index]
        const isPracticeMatching =
          currentSlot?.practiceId === providerDetails.practice.id

        if (isPracticeMatching) {
          shownSlotsCount++
        }
      }
    })
  }

  return {
    generatedSlots,
    dates,
    count: shownSlotsCount,
  }
}
